import { render, staticRenderFns } from "./VrstaTeme2Edit.vue?vue&type=template&id=4ec697d2&scoped=true&"
import script from "./VrstaTeme2Edit.vue?vue&type=script&lang=js&"
export * from "./VrstaTeme2Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec697d2",
  null
  
)

export default component.exports